import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Event from "./Event";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes } from "react-router";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route
        path="/the-test-event"
        element={
          <Event
            eventId={"3ae5c387-79f9-494d-8fb4-de2d2c32843d"}
            eventTitle={"Test Event"}
          />
        }
      />
      <Route
        path="/til-5-nations-tier-1-weekend-hull"
        element={
          <Event
            eventId={"358496bc-6676-4472-8700-7f9acdd4c578"}
            eventTitle={"The Inhuman League"}
          />
        }
      />
      <Route
        path="/sheffield-steel-roller-derby-april-fools-scrim"
        element={
          <Event
            eventId={"1c3517e3-20d6-4817-9c08-d104e2ff43f1"}
            eventTitle={"Sheffield Steel Roller Derby April Fools Scrim"}
          />
        }
      />
      <Route
        path="/sheffield-steel-roller-derby-game-day-rookie-scrim"
        element={
          <Event
            eventId={"2b2dba2a-3fa6-4e03-ab2b-6b92d23d2926"}
            eventTitle={"Sheffield Steel Roller Derby Game Day Bonanza Rookie Scrim"}
          />
        }
      />
      <Route
        path="/sheffield-steel-roller-derby-game-day-ota-scrim"
        element={
          <Event
            eventId={"e884c77a-1113-45b4-9fe3-f38c58c05534"}
            eventTitle={"Sheffield Steel Roller Derby Game Day Bonanza OTA Scrim"}
          />
        }
      />
      <Route
        path="/til-vs-tyne-fear-vs-toulouse-apr-25"
        element={
          <Event
            eventId={"f1c5b313-8c40-4b47-ba35-00294e772265"}
            eventTitle={"The Inhuman League vs Tyne & Fear vs Roller Derby Toulouse"}
          />
        }
      />
    </Routes>
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
